/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReactJWPlayer from 'react-jw-player';

import AddFavorite from 'components/AddFavorite';
import ShareButton from 'components/ShareButton';
import SharingPopup from 'components/SharingPopup';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { appContentUrl, storageKeys } from 'settings';

const trackShare = (type, value, title) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(appId, email, 'videos', type, value, title).then(() => {});
    });
  });
};

export default class TrainingVideo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      qualityIndex: 0,
      quality: [
        { name: '720', hash: 'kTA1qc4f' },
        { name: '406', hash: 'DA7zOnMs' },
        { name: '270', hash: '2oBCa4mK' },
        { name: '180', hash: 'YnNQqrRg' },
      ],
    };
  }

  render() {
    const { image, linkJW1, appId, contentComplete, minTime, autoPlay, params, upID, title } = this.props;

    const { qualityIndex, quality } = this.state;

    return (
      <div className="videoHolder" style={{ position: 'relative' }}>
        <AddFavorite
          appId={appId}
          viewType="p"
          upID={upID}
          pageID={params.pageID}
          title={title}
          url={`https://content.jwplatform.com/videos/${linkJW1}-${quality[qualityIndex].hash}.mp4`}
          bgEnabled
          top
        />
        <ReactJWPlayer
          playerId="video-player"
          playerScript="https://content.jwplatform.com/libraries/gj8NKibk.js"
          file={`https://content.jwplatform.com/videos/${linkJW1}-${quality[qualityIndex].hash}.mp4`}
          image={`${appContentUrl}${appId}/appImages/${image}`}
          isAutoPlay={autoPlay}
          onComplete={contentComplete}
          onReady={() => {
            trackShare(
              'videos',
              `https://content.jwplatform.com/videos/${linkJW1}-${quality[qualityIndex].hash}.mp4`,
              title,
            );
          }}
          onTime={(e) => {
            if (e.duration >= minTime && e.position >= minTime) {
              contentComplete();
            }
          }}
          onError={(e) => {
            console.error(e);
            contentComplete();
            if (qualityIndex < quality.length - 1) {
              this.setState({ qualityIndex: qualityIndex + 1 });
            }
          }}
        />
        <ShareButton
          dataFancyboxTrigger="shareJW"
          title="Share this Video"
          data-fancybox
          dataSource="#shareJW"
          className="trainingContent__shareBtn"
        />
        <SharingPopup
          url={`https://content.jwplatform.com/videos/${linkJW1}-${quality[qualityIndex].hash}.mp4`}
          triggerId="shareJW"
        />
        <style>
          {
            '\
        #openWidget { display: none; bottom: 4rem; } #CookiebotWidget { display: none !important; } .jwplayer { max-height: calc(100vh - 15rem) !important; } .jwplayer.jw-stretch-uniform .jw-media video { object-fit: contain !important; }.trainingBackBtn { max-width: 180rem !important; width: 90% !important; } .trainingContent { max-width: 180rem !important;  width: 90% !important; }'
          }
        </style>
      </div>
    );
  }
}

TrainingVideo.propTypes = {
  linkJW1: PropTypes.string.isRequired,
  image: PropTypes.string,
  minTime: PropTypes.number,
  autoPlay: PropTypes.bool,
  appId: PropTypes.number.isRequired,
  contentComplete: PropTypes.func,
  params: PropTypes.shape(),
  upID: PropTypes.string,
  title: PropTypes.string,
};

TrainingVideo.defaultProps = {
  autoPlay: true,
  image: '',
  minTime: 30,
  contentComplete: () => {},
  upID: '',
  params: {},
  title: '',
};
